<div class="note">
  @if (note !== null) {
    <span [nbTooltip]="noteTooltip" nbTooltipPlacement="top"
      [nbTooltipStatus]="note >= 75 ? 'success' : note >= 50 ? 'warning' : note >= 25 ? 'control' : 'danger'"
  [ngClass]="{
    'new': note > 75 && (!asset || (asset && !asset.parent)),
    'good-condition': note > 50 && note <= 75 && (!asset || (asset && !asset.parent)),
    'aging': note > 25 && note <= 50 && (!asset || (asset && !asset.parent)),
    'deteriorated': note > 0 && note <= 25 && (!asset || (asset && !asset.parent)),
    'child': asset && asset.parent
  }">{{ note | number:'1.0-0' }}@if (note) {
      <span class="scale">/ 100</span>
    }</span>
  }
  @if (note === null && !nbAssets && !asset) {
    <span>-</span>
  }
  @if (note === null && asset) {
    <span class="waiting-notation">{{ 'asset.waiting_notation' | translate}}</span>
  }
  @if (note === null && missingReasonLabel) {
    <div class="notation-missing-reason">({{ missingReasonLabel }})</div>
  }
</div>
@if (note !== null) {
  <div class="nb_asset">
    @if (!lastNotationYear) {
      <span>{{ noteLabel }} </span>
    }
    @if (lastNotationYear) {
      <span>{{ 'Assessed {state} in {year}' | translate:{state:noteLabel, year:lastNotationYear} }}</span>
    }
  </div>
}
